export const extractHeaderContent = data => {
  const content = data?.header;
  const headerMenu = content?.fields?.mixedList?.[0]?.fields?.list?.[0]?.fields?.navMenu;

  return {
    logo: headerMenu?.[0]?.fields?.media?.fields?.image?.fields?.file?.url,
    secondaryCTA: headerMenu?.[2]?.fields?.cta?.fields?.label,
    primaryCTA: headerMenu?.[1]?.fields?.cta?.fields?.label,
    aboutUsCTA: headerMenu?.[3]?.fields?.cta?.fields?.label,
    teachCTA: headerMenu?.[4]?.fields?.cta?.fields?.label,
  };
};

export const extractFooterContent = data => {
  const content = data?.footer;
  const footerMenu = content?.fields?.mixedList?.[0]?.fields?.list?.[0]?.fields?.navMenu;

  return {
    emailIcon: footerMenu?.[5]?.fields?.media?.fields?.image?.fields?.file?.url,
    whatsAppIcon: footerMenu?.[6]?.fields?.media?.fields?.image?.fields?.file?.url,
    titles: {
      information: footerMenu?.[11]?.fields?.title,
      about: footerMenu?.[12]?.fields?.title,
    },
    aboutUs: {
      join: footerMenu?.[13]?.fields?.title,
      about: footerMenu?.[14]?.fields?.title,
      school: footerMenu?.[17]?.fields?.title,
      spaces: footerMenu?.[18]?.fields?.title,
    },
    socials: footerMenu?.slice(-3)?.map(f => ({
      title: f?.fields?.title,
      url: f?.fields?.url,
      icon: f?.fields?.media?.fields?.image?.fields?.file?.url,
    })),
    contactInfo: {
      email: footerMenu?.[5]?.fields?.title,
      phone: footerMenu?.[6]?.fields?.title,
      address: footerMenu?.[10]?.fields?.title,
      addressLink: footerMenu?.[10]?.fields?.url,
    },
    companyInfo: {
      copyRight: footerMenu?.[7]?.fields?.title,
      companyNumber: footerMenu?.[8]?.fields?.title,
      quotation: footerMenu?.[19]?.fields?.title,
    },
    legals: {
      terms: footerMenu?.[0]?.fields?.title,
      privacy: footerMenu?.[1]?.fields?.title,
    },
    educators: {
      signup: footerMenu?.[15]?.fields?.title,
      signin: footerMenu?.[16]?.fields?.title,
    },
  };
};
